import { ReactNode, createContext, useContext, useState } from 'react';
import { JobListDefn } from '../../index';

type JobCarouselContextType = {
    jobs: JobListDefn;
    setJobs: (jobList: JobListDefn) => void;
    isLoading: boolean;
    setIsLoading: (isLoading: boolean) => void;
};

const JobCarouselContext = createContext<JobCarouselContextType | undefined>(
    undefined
);
export const JobCarouselProvider = ({
    children,
}: {
    children: ReactNode;
}): JSX.Element => {
    const [jobs, setJobs] = useState<JobListDefn>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    return (
        <JobCarouselContext.Provider
            value={{
                jobs,
                setJobs,
                isLoading,
                setIsLoading,
            }}
        >
            {children}
        </JobCarouselContext.Provider>
    );
};

export const useJobCarousel = () => {
    const context = useContext(JobCarouselContext);
    if (context === undefined) {
        throw new Error(
            'useJobCarousel must be used within a JobCarouselProvider'
        );
    }
    return context;
};
